import { BaseApi, enhanceOpt } from '../couplingAjax'
import { Services } from '@/store/StoreTypes'

// http://172.16.103.12/message-api/doc.html#/home

const MessageApi = (request: typeof BaseApi, SERVIVE: Services) => {
  return {
    // 我的消息列表
    queryMessageList: (opt: enhanceOpt) =>
      request({
        ...opt,
        url: `/message/listMessagePrivate`,
        method: 'post',
      }),
    queryMessageInfo: (opt: enhanceOpt) =>
      request({
        ...opt,
        url: `/message/queryMessageInfoPrivate`,
        method: 'post',
      }),
    queryManageList: (opt: enhanceOpt) =>
      request({
        ...opt,
        url: `/message/listMessage`,
        method: 'post',
      }),
    saveOrUpdateMessage: (opt: enhanceOpt) =>
      request({
        ...opt,
        url: `/message/saveOrUpdateMessage`,
        method: 'post',
      }),
    saveMessageRecord: (opt: enhanceOpt) =>
      request({
        ...opt,
        url: `/message/saveMessageRecord`,
        method: 'post',
      }),
    modifyAllMessageRead: (opt: enhanceOpt) =>
      request({
        ...opt,
        url: `/message/modifyAllMessageRead`,
        method: 'get',
      }),
    deleteMessage: (opt: enhanceOpt) =>
      request({
        ...opt,
        url: `/message/deleteMessage`,
        method: 'get',
      }),
  }
}

export default MessageApi
